import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="file-input-trigger"
export default class extends Controller {
  static targets = ["fileInput"];

  connect() {
    // Make the entire form area clickable
    this.element.addEventListener("click", this.handleClick.bind(this));
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick.bind(this));
  }

  handleClick(event) {
    // Don't trigger if clicking directly on the file input
    if (event.target.type === "file") {
      return;
    }

    // Prevent button default behavior
    if (event.target.tagName === "BUTTON" || event.target.closest("button")) {
      event.preventDefault();
    }

    if (this.hasFileInputTarget) {
      this.fileInputTarget.click();
    }
  }

  trigger() {
    if (this.hasFileInputTarget) {
      this.fileInputTarget.click();
    }
  }
}
